export default "__VITE_ASSET__4mL2hZHH__"